import { useEffect } from 'react';
import { useIsTranslationsEnabled } from './useIsTranslationsEnabled';

export const useSupportTranslationsIfRequired = () => {
  const isTranslationsEnabled = useIsTranslationsEnabled();

  useEffect(() => {
    if (!isTranslationsEnabled) {
      return;
    }

    const htmlTag = document.querySelector('html');
    const isDevelopmentEnvironment =
      process.env.REACT_APP_ENVIRONMENT === 'development';

    htmlTag?.removeAttribute('translate');

    if (typeof Node === 'function' && Node.prototype) {
      const originalRemoveChildFunc = Node.prototype.removeChild;
      Node.prototype.removeChild = function <T extends Node>(child: T): T {
        if (child.parentNode !== this) {
          if (isDevelopmentEnvironment && console) {
            console.error(
              'Translation error - Cannot remove a child from a different parent',
              child,
              this,
            );
          }
          return child;
        }
        return originalRemoveChildFunc.call(this, child) as T;
      };

      const originalInsertBeforeFunc = Node.prototype.insertBefore;
      Node.prototype.insertBefore = function <T extends Node>(
        newNode: T,
        referenceNode: Node,
      ): T {
        if (referenceNode && referenceNode.parentNode !== this) {
          if (isDevelopmentEnvironment && console) {
            console.error(
              'Translation error - Cannot insert before a reference node from a different parent',
              referenceNode,
              this,
            );
          }
          return newNode;
        }
        return originalInsertBeforeFunc.call(this, newNode, referenceNode) as T;
      };
    }
  }, [isTranslationsEnabled]);
};
